import type { Menu } from '@/menus/types.ts';
export default [
  {
    code: 'BASE_DATA_DAILY_EXCHANGE_RATE',
    icon: 'menu-daily-exchange-rate',
    label: '每日汇率',
    path: '/base-data/daily-exchange-rate',
  },
] satisfies Menu[];
